var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemCursosIconStroke(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#add8e6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.32.11a23.93,23.93,0,0,0-8.61.76,26.8,26.8,0,0,0-4.07,1.47A29,29,0,0,0,16,3.73a27.72,27.72,0,0,0-2.64-1.39A26.41,26.41,0,0,0,9.29.87,23.93,23.93,0,0,0,.68.11.76.76,0,0,0,0,.87V23.79a.8.8,0,0,0,.24.56.75.75,0,0,0,.59.18,23.3,23.3,0,0,1,7.67.56,27.13,27.13,0,0,1,7.07,2.77.07.07,0,0,0,0,0,.64.64,0,0,0,.19.08A.63.63,0,0,0,16,28l.17,0,.1,0,.1-.05h0l0,0a27,27,0,0,1,7.08-2.78,23.3,23.3,0,0,1,7.67-.56.74.74,0,0,0,.59-.18.8.8,0,0,0,.24-.56V.87A.76.76,0,0,0,31.32.11ZM15.24,26a28.35,28.35,0,0,0-6.39-2.37A25.47,25.47,0,0,0,1.52,23V1.56a22.52,22.52,0,0,1,7.37.77,24.87,24.87,0,0,1,3.84,1.39A25,25,0,0,1,15.24,5Zm15.24-3a25.47,25.47,0,0,0-7.33.64A28.5,28.5,0,0,0,16.76,26V5a25.31,25.31,0,0,1,6.35-2.71,22.25,22.25,0,0,1,7.37-.77Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.53,27.77h0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemCursosIconStroke);
export default __webpack_public_path__ + "static/media/item_cursos_icon_stroke.22d4512a0f69e5ce325f96fc2bcceb26.svg";
export { ForwardRef as ReactComponent };